module.exports = __webpack_public_path__ + "static/media/bookr_book_view.fd480090.png";